import { isMobileOnly } from "react-device-detect";
import { makeStyles } from "./index";
import { COLORS } from "../themes/Base";

export default makeStyles()((theme) => ({
  mainCol: {
    maxWidth: "calc(100% - 300px)",
  },
  contentBox: {
    backgroundColor: "##FEFFF8",
    padding: theme.spacing(4),
  },
  inputBox: {
    paddingBottom: theme.spacing(2),
  },
  contentTable: {
    "& tfoot td": {
      borderBottom: "none",
    },
  },
  mobileContentTable: {
    "& tr": {
      display: "flex",
      flexWrap: "wrap",
      "& td": {
        display: "block",
        width: "100%",
        borderBottom: "none",
        "&.settings-cell": {
          paddingBottom: 0,
        },
        "&.name-cell": {
          paddingTop: 0,
        },
        "&:last-child": {
          borderBottom: "1px solid #c3c3c3",
        },
      },
    },
  },
  responsesContentTable: {
    "& td": {
      whiteSpace: "nowrap",
    },
  },
  itemWrapper: {
    display: "flex",
    alignItems: "center",
    "*:first-of-type": {
      marginRight: theme.spacing(1),
    },
  },
  itemName: {
    fontSize: 16,
    fontWeight: 400,
    "&.link": {
      color: theme.palette.text.primary,
      textDecoration: "none",
      transition: "all 0.3s",
      "&:hover": {
        color: theme.palette.secondary.main,
      },
    },
  },
  itemSubName: {
    fontSize: 12,
    fontWeight: 500,
    color: theme.palette.text.secondary,
    paddingTop: theme.spacing(1),
  },
  settingsButton: {
    color: theme.palette.text.secondary,
  },
  dropdownMenu: {
    padding: theme.spacing(0.5),
  },
  dropdownMenuItem: {
    fontSize: 14,
    fontWeight: 500,

    "&.red": {
      color: COLORS.error,
    },

    "& svg": {
      width: 18,
      marginRight: theme.spacing(1.5),
      color: theme.palette.text.primary,
    },
  },

  itemStats: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: isMobileOnly ? "wrap" : "nowrap",
  },
  itemStatsElement: {
    position: "relative",
    display: isMobileOnly ? "flex" : "block",
    alignItems: "center",
    flexBasis: isMobileOnly ? "50%" : "20%",
    flexGrow: isMobileOnly ? 1 : 0,
    textAlign: isMobileOnly ? "left" : "center",
    padding: isMobileOnly ? theme.spacing(0, 2, 1.5, 0) : theme.spacing(0, 2, 1.5),
    fontSize: 11,
    textTransform: "uppercase",
    "& > div:last-child": {
      whiteSpace: "nowrap",
      paddingLeft: isMobileOnly ? theme.spacing(1) : 0,
    },
  },
  itemStatsNumber: {
    fontWeight: 700,
    fontSize: 16,
    "&.total": {
      fontSize: 16,
    },
    "&.negative": {
      color: "rgb(244, 91, 84)",
    },
    "&.positive": {
      color: "rgb(35, 182, 154)",
    },
    "&.neutral": {
      color: "rgb(252, 183, 43)",
    },
  },
  itemStatsSub: {
    fontSize: 12,
    color: theme.palette.grey[500],
    display: "inline-block",
    paddingLeft: theme.spacing(0.5),
    position: "absolute",
    "&.static": {
      position: "static",
    },
  },

  tag: {
    borderRadius: "128px",
    textTransform: "capitalize",
  },
  tagPositive: {
    background: "#E9F8F1",
    color: "#15663F",
  },
  tagNeutral: {
    backgroundColor: "#FDF6EA",
    color: "#83591A",
  },
  tagNegative: {
    backgroundColor: "#EAEAED",
    color: "#4F4F52",
  },

  pagination: {
    "& .MuiPagination-ul": {
      flexWrap: "nowrap",
      justifyContent: "right",
    },
    "& .MuiButtonBase-root": {
      margin: 0,
    },
    "& .MuiPaginationItem-root": {
      minWidth: 24,
      height: 24,
      fontSize: 14,
    },
    "& .Mui-selected": {
      background: "transparent",
      color: COLORS.secondary,
      fontWeight: 700,
    },
  },
  innerBox: {
    borderRadius: "8px",
    border: "1px solid  #E4E8D3",
    background: "#FFF",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.04)",
    marginTop: "8px",
    maxHeight: "400px",
  },
  tableHeaderCell: {
    height: "44px",
    minWidth: "150px",
    padding: "0 24px",
    textAlign: "center",
    alignSelf: "stretch",
    borderBottom: "1px solid #E4E8D3",
    background: "#F8F8F9",
    color: "#67676C",
    fontSize: "12px",
    lineHeight: "18px",
    "& .MuiSvgIcon-root": {
      fontSize: 15,
      fontWeight: 600,
      verticalAlign: "middle",
      cursor: "pointer",
    },
  },
  tableBodyCell: {
    color: "#67676C",
    fontSize: "16px",
    textAlign: "center",
  },
  tableFooterCell: {
    position: "sticky",
    boxShadow: "0 -6px 24px 0 rgba(0, 0, 0, 0.03)",
    fontSize: "16px",
    textAlign: "center",
    fontWeight: 700,
    color: "#252525",
    height: "96px",
    zIndex: 10,
    bottom: 0,
    background: "#FEFFF8",
  },
  urlBox: {
    background: "#fff",
    border: "1px solid #E4E8D3",
    borderRadius: "10px",
    padding: "12px 16px",
    fontSize: 15,
    display: "flex",
    alignItems: "center",
    color: COLORS.textPrimary,
  },
  fieldBox: {
    marginBottom: "16px",
    alignItems: "center",
    "& .MuiFormLabel-root": {
      fontSize: 14,
      color: "#000",
      marginBottom: "4px",
    },
    "& .MuiOutlinedInput-input": {
      fontSize: 15,
      color: "#000",
    },
  },
  borderedBox: {
    paddingTop: "16px",
    paddingLeft: "16px",
    paddingRight: "16px",
    marginBottom: "16px",
    border: `1px solid ${COLORS.inputBorder}`,
    borderRadius: "8px",
  },
  endpointParameterAdornment: {
    backgroundColor: "#EAEAED",
    padding: "9px",
    color: "#85858B",
    fontSize: "15px",
    display: "flex",
    alignItems: "center",
  },
  endpointParameterField: {
    width: "260px",
    margin: 0,
    "& .MuiInputBase-input": {
      textAlign: "center",
    },
  },
  dialogModalBox: {
    backgroundColor: "#FEFFF8",
    borderRadius: "16px",
    padding: 0,
    border: "1px solid #E4E8D3",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.04)",
  },
  stickyHeader: {
    display: "block",
    padding: "32px",
    boxShadow: "0 6px 24px 0 rgba(0, 0, 0, 0.05)",
    position: "fixed",
    width: "calc(100% - 76px)",
    top: 0,
    zIndex: 10,
    backgroundColor: COLORS.background,
    borderBottom: COLORS.inputBorder,
  },
  projectStatRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexWrap: "nowrap",
    overflowX: "auto",
    padding: 16,
  },
  projectStatItem: {
    textAlign: "left",
    minWidth: 100,
    flex: "0 0 auto",
    "& .MuiTypography-root": {
      whiteSpace: "nowrap",
    },
  },
  terminatedBreakdown: {
    backgroundColor: "#fff",
    color: COLORS.textSecondary,
    boxShadow: "0px 8px 32px rgba(16, 24, 40, 0.18), 0px 1.5px 4px rgba(16, 24, 40, 0.08)",
    padding: "8px 14px",
    fontSize: "14px",
    borderRadius: "12px",
  },
}));
